import { Fragment, useState } from "react";
import { Navigation } from "swiper";
import { Add } from "@mui/icons-material";

import { Avatar, MenuItem, Typography } from "@mui/material";
import styled from "styled-components/macro";
import { useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { useDispatch, useSelector } from "react-redux";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import pages from "../../../constants/pages";
import { TextField } from "../../../components";
import { signInMember, signOutMember } from "../../../redux/slices/memberSlice";
import {
  PrimaryButton,
  PrimaryLoadingButton,
} from "../../css components/Button";
import { colors } from "../../css components/Style";
import dashboardLayoutRoutes from "../../../router/router components/dashboardLayoutRoutes";
import ENV from "../../../config/config";

const Image = styled.div`
  margin-top: 20px;
  height: 180px;
  width: 180px;
  display: flex;
  justify-content: center;
  border-radius: 50%;
  cursor: pointer;
`;

export default function SelectRole({
  businessEntityID,
  brands,
  authToken,
  userID,
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { siteColors } = useSelector((state) => state.renderUIDetails);

  const role = useSelector((state) => state?.memberDetails.role);

  const agencyID =
    useSelector((state) => state?.memberDetails.agencyID) ||
    sessionStorage.getItem("agencyID");

  const { dashboardState, brandType, activeBrand } = useSelector(
    (state) => state.memberDetails
  );

  const [currentBrand, setCurrentBrand] = useState({
    ID: activeBrand.ID,
    name: activeBrand.name,
    type: activeBrand.brandType || brandType,
  });

  const [userDashboardState, setUserDashboardState] = useState(
    dashboardState || "monetization"
  );

  return (
    <Fragment>
      <div className="outer-brand-div">
        <div className="select-brand-div">
          {brands.length > 0 && (
            <Fragment>
              <Swiper
                slidesPerView={3}
                spaceBetween={1}
                navigation={true}
                modules={[Navigation]}
                className="mySwiper"
              >
                {brands.map((brand) => (
                  <Fragment>
                    <div
                      className="swiper-wrapper"
                      style={{
                        width: brands.length !== 1 && "fit-content",
                      }}
                    >
                      <SwiperSlide>
                        <Image
                          style={{
                            opacity:
                              (brand.isBrandVerified === 0 ||
                                brand.isBrandVerified === 2) &&
                              0.4,
                            pointerEvents:
                              (brand.isBrandVerified === 0 ||
                                brand.isBrandVerified === 2) &&
                              "none",
                          }}
                          onClick={() =>
                            setBrand(brand.ID, brand.brandName, brand.brandType)
                          }
                        >
                          <img
                            className="img-logo"
                            style={{
                              cursor: "pointer",
                              border:
                                currentBrand.ID === brand.ID &&
                                `1px solid ${siteColors?.primary} `,
                            }}
                            src={brand.logo}
                            alt="logo"
                          />
                          <Typography className="brand-name">
                            {brand.brandName}
                          </Typography>
                        </Image>
                      </SwiperSlide>
                    </div>
                  </Fragment>
                ))}
              </Swiper>

              <div className="choose-ds">
                <TextField
                  size="small"
                  select
                  placeholder="Select Role"
                  name="role"
                  value={userDashboardState}
                  onChange={setDashboardUser}
                  disabled={currentBrand.type !== 3}
                >
                  <MenuItem value={`promotion`}>I am Data Contributor</MenuItem>
                  <MenuItem value={`monetization`}>I am Data Consumer</MenuItem>
                </TextField>
              </div>
            </Fragment>
          )}

          {brands.length === 0 && (
            <div onClick={() => addNewBrand()} className="add-new-brand">
              <Avatar
                style={{
                  background: colors.green,
                  margin: "auto",
                  width: "50px",
                  height: "50px",
                }}
              >
                <Add />
              </Avatar>
              <Typography
                style={{ textAlign: "center" }}
                variant="subtitle1"
                color={colors.green}
              >
                Add New Brand
              </Typography>
            </div>
          )}
        </div>
      </div>

      <div className="bottom-div">
        <div>
          <PrimaryButton
            style={{ float: "left" }}
            variant="outlined"
            onClick={() => {
              const ida_sso_login = sessionStorage.getItem("ida_sso_login");
              if (ida_sso_login === "true") {
                if (ENV === "main") {
                  window.location = "https://ida.ioh.id/";
                }
                if (ENV === "dev") {
                  window.location = "https://ida-dev.gammasprint.com/";
                }
              }

              dispatch(signOutMember());
            }}
          >
            Logout
          </PrimaryButton>
        </div>

        <div style={{ gap: 5 }}>
          {agencyID && (
            <PrimaryButton
              style={{ float: "left", marginRight: "20px" }}
              variant="outlined"
              onClick={() => addNewBrand()}
            >
              Add New Brand
            </PrimaryButton>
          )}

          {agencyID && (
            <PrimaryButton
              style={{ float: "left", marginRight: "20px" }}
              variant="outlined"
              onClick={() => handleAgency()}
            >
              Agency Dashboard
            </PrimaryButton>
          )}

          {brands.length > 0 && (
            <PrimaryLoadingButton
              style={{ float: "right" }}
              type="submit"
              variant="contained"
              disabled={!Boolean(currentBrand.ID)}
              onClick={async () => {
                if (role === "AGENCY") {
                }
                sessionStorage.setItem("role", "NORMAL_USER");
                localStorage.setItem(
                  "dashboardState" + currentBrand.ID,
                  userDashboardState
                );
                await dispatch(
                  signInMember({
                    authToken: authToken,
                    userID: userID,
                    businessEntityId: businessEntityID,
                    brandType: currentBrand.type,
                  })
                );

                navigate(pages.brandDetails.route);
              }}
            >
              Let's Go
            </PrimaryLoadingButton>
          )}
        </div>
      </div>
    </Fragment>
  );

  async function addNewBrand() {
    localStorage.setItem("dashboardState" + currentBrand.ID, "monetization");
    navigate(pages.brandDetailCreateEmpty.route + "?newMultiBrand=" + true);
  }

  async function handleAgency() {
    sessionStorage.setItem("role", "AGENCY");
    await dispatch(
      signInMember({
        authToken: authToken,
        userID: userID,
        businessEntityId: businessEntityID,
        brandType: currentBrand.type,
      })
    );

    navigate(
      dashboardLayoutRoutes.agencyDetailsRoute.path + "?agencyID=" + agencyID
    );
  }

  function setBrand(ID, name, type) {
    if (type === 2) {
      setUserDashboardState("monetization");
    }
    if (type === 3) {
      setUserDashboardState("promotion");
    }

    setCurrentBrand({
      ID: ID,
      name: name,
      type: type,
    });
    sessionStorage.setItem("activeBrand", ID);
    sessionStorage.setItem("brandType", type);
  }

  function setDashboardUser(e) {
    setUserDashboardState(e.target.value);
  }
}
